var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-advantages-item"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.info.imgUrl}})]),_c('div',{staticClass:"right-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.info.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }